import { Messages } from '../../../codegen/Localize';
import { LicensingTier } from '../resources/SiteRoleOptions';

const licenseTierLocKeyDict: Record<LicensingTier, () => string> = {
  'Creator': Messages.license_Creator,
  'Viewer': Messages.license_Viewer,
  'Explorer': Messages.license_Explorer,
  'Unlicensed': Messages.license_Unlicensed
};

function filter(licenseTier: LicensingTier): string {
  return licenseTier ? licenseTierLocKeyDict[licenseTier]():'';
}

export const LicenseTierFilter = {
  filter
};
